module.exports = __webpack_public_path__ + "img/電気回路_4_2_2.1e318c9e.png";